import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const tabs = [
  { to: '/', key: 'navHome', icon: 'ri-home-5-line' },
  { to: '/category/movie', key: 'navCategories', icon: 'ri-apps-2-line' },
  { to: '/search', key: 'navSearch', icon: 'ri-search-line' },
  { to: '/favorites', key: 'navFavorites', icon: 'ri-heart-3-line' },
  { to: '/about', key: 'navAbout', icon: 'ri-information-line' },
];

export default function MobileTabBar() {
  const { t } = useTranslation();
  const location = useLocation();

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    if (to === '/category/movie') return location.pathname.startsWith('/category');
    return location.pathname.startsWith(to);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-background-200 bg-background-50/95 backdrop-blur-md md:hidden">
      <div className="grid grid-cols-5">
        {tabs.map((tab) => {
          const active = isActive(tab.to);
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={`flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition cursor-pointer ${
                active ? 'text-accent-600' : 'text-foreground-500'
              }`}
            >
              <i className={`${tab.icon} text-xl`}></i>
              {t(tab.key)}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}